import React, { useState } from "react";
import Layout from "../Common/Layout";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OutboundKataSlip = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    companyName: "AgroBuild Pvt. Ltd",
    contactNo: "+91-9897989798",
    address: "KPM Villa, North Sikkim",
    product: "Coffee Beans",
    quantity: "80",
    quality: "B+",
    date: "2025-11-11",
    tentativeStorageDate: "2026-09-01",
    file: null,
  });

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  // ✅ Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    toast.success("✅ Data submitted successfully!", {
      position: "top-right",
      autoClose: 2000,
      theme: "colored",
    });

    setTimeout(() => {
      navigate("/outbound-kata-slip-data");
    }, 2500);
  };

  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div
                      className="card-body p-4"
                      style={{ backgroundColor: "#3075A6" }}
                    >
                      <h4 className="card-title mb-4 text-center fw-semibold text-primary">
                        Outbound Kata Slip (Loaded Truck) Upload
                      </h4>

                      <form onSubmit={handleSubmit}>
                        {/* File Upload */}
                        <div className="mb-3">
                          <label
                            htmlFor="file"
                            className="form-label fw-semibold"
                          >
                            Upload Kata Slip
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="file"
                            name="file"
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Submit Button */}
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary px-5 py-2 fw-semibold"
                          >
                            Upload Kata Slip
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Toast Container */}
        <ToastContainer />
      </Layout>
    </>
  );
};

export default OutboundKataSlip;
